module.exports = __webpack_public_path__ + "static/media/ic-instant-book-yellow.a02f554b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-instant-book-yellow.svg
// module id = 631
// module chunks = 14